import Event from '../../core/Event';

export default class EstimationProductsGetRequested extends Event {
    public static type = 'EstimationProductsGetRequested';

    constructor() {
        super(EstimationProductsGetRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/EstimationProductsGetRequested.ts